/*
 * 제품 상세페이지: 접이식(아코디언) 메뉴들을 '가로 탭'으로 바꿔줌
 * - 제목들을 한 줄로 나란히 표시
 * - 클릭하면 그 내용만 아래에 보임, 선택된 탭엔 밑줄
 * - JS가 안 되면 원래 접이식으로 그대로 작동(안전)
 */
(function () {
  function initProductTabs(root) {
    if (!root) return;

    const accordions = root.querySelectorAll('.product__accordion');
    if (accordions.length < 2) return;
    if (root.querySelector('.product-tabs__nav')) return;

    const nav = document.createElement('div');
    nav.className = 'product-tabs__nav';
    nav.setAttribute('role', 'tablist');

    const panels = [];
    const tabs = [];

    accordions.forEach(function (acc, index) {
      const details = acc.querySelector('details');
      const titleEl = acc.querySelector('.accordion__title');
      const title = titleEl ? titleEl.textContent.trim() : 'Tab ' + (index + 1);

      if (details) details.open = true;
      acc.classList.add('product-tabs__panel');
      panels.push(acc);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-tabs__tab';
      btn.setAttribute('role', 'tab');
      btn.textContent = title;
      btn.addEventListener('click', function () {
        activate(index);
      });
      nav.appendChild(btn);
      tabs.push(btn);
    });

    accordions[0].parentNode.insertBefore(nav, accordions[0]);

    function activate(idx) {
      tabs.forEach(function (t, i) {
        const on = i === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
      });
    }

    activate(0);
  }

  // 수량 선택 + 장바구니 버튼을 한 줄(가로)로 묶기
  function initQtyAtcRow(root) {
    const qty = root.querySelector('.product-form__quantity');
    if (!qty) return;
    if (qty.closest('.qty-atc-row')) return;

    const form = root.querySelector('product-form') || root.querySelector('.product-form');
    if (!form) return;

    const row = document.createElement('div');
    row.className = 'qty-atc-row';
    qty.parentNode.insertBefore(row, qty);
    row.appendChild(qty);
    row.appendChild(form);
  }

  function initAll() {
    document.querySelectorAll('[id^="ProductInfo-"]').forEach(function (root) {
      initProductTabs(root);
      initQtyAtcRow(root);
    });
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // 테마 편집기에서 섹션을 다시 그릴 때도 작동하도록
  document.addEventListener('shopify:section:load', initAll);
})();
